export function RemoveButtonPlugin() {
  const tomSelect = this

  tomSelect.hook("after", "setupTemplates", () => {
    const renderItem = tomSelect.settings.render.item

    tomSelect.settings.render.item = (data, escape) => {
      const item = itemElement(renderItem.call(tomSelect, data, escape))

      const label = document.createElement("span")
      label.append(...item.childNodes)

      const name = `Remove ${data[tomSelect.settings.labelField]}`

      const button = document.createElement("button")
      button.setAttribute("type", "button")
      button.setAttribute("tabindex", "-1")
      button.setAttribute("title", name)
      button.setAttribute("aria-label", name)
      button.setAttribute("class", "remove-button")

      item.append(label, button)

      return item
    }
  })

  tomSelect.hook("after", "setup", () => {
    tomSelect.wrapper.addEventListener("mousedown", onMousedown, true)
    tomSelect.wrapper.addEventListener("click", onClick, true)
  })

  tomSelect.hook("instead", "onItemSelect", () => false)
  tomSelect.hook("instead", "selectAll", () => {})

  function onMousedown(event) {
    if (!removeButton(event)) {
      return
    }

    event.preventDefault()
    event.stopPropagation()
  }

  function onClick(event) {
    const button = removeButton(event)

    if (!button) {
      return
    }

    event.preventDefault()
    event.stopPropagation()

    if (tomSelect.isLocked) {
      return
    }

    tomSelect.removeItem(button.closest("[data-ts-item]"))

    if (!tomSelect.isOpen) {
      tomSelect.focus_node.focus({ preventScroll: true })
    }
  }

  function itemElement(rendered) {
    if (rendered instanceof HTMLElement) {
      return rendered
    }

    const template = document.createElement("template")
    template.innerHTML = rendered

    return template.content.firstElementChild
  }

  function removeButton(event) {
    return event.target.closest(".remove-button")
  }
}
